import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "cart__count" };
const _hoisted_2 = { class: "cart__total" };
const _hoisted_3 = {
    key: 0,
    class: "cart__selection"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "cart__count" };
const _hoisted_6 = { class: "cart__total" };
const _hoisted_7 = { class: "cart__customer" };
const _hoisted_8 = {
    key: 1,
    class: "cart__items"
};
const _hoisted_9 = { class: "cart__items-title" };
const _hoisted_10 = { class: "cart__item-image" };
const _hoisted_11 = ["src"];
const _hoisted_12 = { class: "cart__item-content" };
const _hoisted_13 = { class: "cart__item-sku" };
const _hoisted_14 = { class: "cart__item-product" };
const _hoisted_15 = { class: "cart__item-actions" };
const _hoisted_16 = ["onClick", "title"];
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from "vue-router";
import cartRepository from '@astina/paloma-shop-common-ui/src/services/CartRepository';
import productUtils from '@astina/paloma-shop-common-ui/src/services/ProductUtils';
import env from '../services/AppEnv';
import events from '@astina/paloma-common-ui/src/services/EventBus';
import { activateCart } from "../commands/ActivateCart";
import { updateCartItems } from "../commands/UpdateCartItems";
import Price from "@astina/paloma-shop-common-ui/src/components/Price.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import AppDropdown from "@astina/paloma-common-ui/src/components/AppDropdown.vue";
import { isGranted } from "@astina/paloma-common-ui/src/services/AccessManager";
import sidebarContext, { SIDEBAR_STATE_CHANGED } from "../services/AppSidebarContext";
import CreateOrderDraft from "../commands/CreateOrderDraft";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShoppingCart',
    setup(__props) {
        const route = useRoute();
        const CART_EVENTS = [
            'command.update_cart_items.success',
            'command.purchase_order.success',
            'command.delete_order_draft.success',
        ];
        const ITEM_ADDED_EVENTS = [
            'command.add_cart_items.success',
            'command.add_watchlist_items_to_cart.success',
        ];
        const carts = ref([]);
        const cart = ref(null);
        const addedItems = ref([]);
        const addedItemsTimeout = ref(null);
        const cartSidebarOpen = ref(false);
        const loading = ref(false);
        const createOrderDraft = ref(new CreateOrderDraft());
        onMounted(() => {
            loadCarts();
            events.$on(CART_EVENTS, loadCarts);
            events.$on(ITEM_ADDED_EVENTS, onAddCartItems);
            events.$on('command.create_order_draft.success', onCreateCart);
            events.$on('cart-loaded', onCartLoaded);
            sidebarContext.$on(SIDEBAR_STATE_CHANGED, () => {
                cartSidebarOpen.value = sidebarContext.isCartSidebarOpen();
            });
        });
        onUnmounted(() => {
            events.$off(CART_EVENTS, loadCarts);
            events.$off(ITEM_ADDED_EVENTS, onAddCartItems);
            events.$off('command.create_order_draft.success', onCreateCart);
            events.$off('cart-loaded', onCartLoaded);
        });
        function toggleCartSidebar() {
            sidebarContext.toggleActiveCart();
        }
        function selectCart(newCart) {
            cart.value = newCart;
            return activateCart(cart.value.id);
        }
        function loadCarts() {
            if (!isGranted('PORTAL_ORDERS_CREATE')) {
                return;
            }
            loading.value = true;
            cartRepository.listCarts()
                .then(data => {
                carts.value = data;
                if (carts.value.length === 0) {
                    cart.value = null;
                    return;
                }
                if (env.orders.activeDraft) {
                    cart.value = carts.value.find(c => c.id === env.orders.activeDraft)
                        || carts.value[0];
                }
                else {
                    cart.value = carts.value[0];
                }
                if (cart.value.id !== env.orders.activeDraft) {
                    activateCart(cart.value.id);
                }
            })
                .finally(() => {
                loading.value = false;
            });
        }
        function onCreateCart(cart) {
            loadCarts();
            selectCart(cart)
                .then(() => {
                if (route['name'] !== 'orders_draft') {
                    sidebarContext.openActiveCart();
                }
            });
        }
        function onAddCartItems(otherCart) {
            loadCarts();
            addedItems.value = (cart.value && cart.value.id === otherCart.id)
                ? (otherCart.addedItems || [])
                : [];
            // TODO show UI indicator
            if (addedItemsTimeout.value) {
                window.clearTimeout(addedItemsTimeout.value);
            }
            addedItemsTimeout.value = window.setTimeout(() => {
                addedItems.value = [];
            }, 5000);
        }
        // Reading a single cart re-prices it, listing carts does not. Take the
        // totals from the loaded cart, otherwise we keep showing the ones from
        // before the re-price.
        function onCartLoaded(loaded) {
            if (!cart.value || cart.value.id !== loaded.id) {
                return;
            }
            cart.value.orderTotal = loaded.taxIncluded
                ? loaded.orderPricing.grossPriceFormatted
                : loaded.orderPricing.netPriceFormatted;
            cart.value.itemsCount = loaded.items.length;
        }
        function undoAddCartItem(item) {
            updateCartItems([{
                    itemId: item.id,
                    quantity: item.quantity * -1,
                }], cart.value.id)
                .then(() => {
                // Remove from items list
                addedItems.value.splice(addedItems.value.indexOf(item), 1);
            });
        }
        function itemImageSrc(item) {
            const image = item.image && productUtils.createImage(item.image);
            return image && image.url || '';
        }
        function onClickIcon() {
            if (cart.value) {
                toggleCartSidebar();
                return;
            }
            if (loading.value) {
                return;
            }
            if (isGranted('PORTAL_ORDERS_CREATE')) {
                createOrderDraft.value.enqueue();
            }
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_ctx.$isGranted('PORTAL_ORDERS_CREATE'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["cart", { 'cart--active': cartSidebarOpen.value }])
                }, [
                    _createElementVNode("div", {
                        class: "cart__icon",
                        onClick: _cache[0] || (_cache[0] = ($event) => (onClickIcon()))
                    }, [
                        _createVNode(_component_icon, {
                            name: "shopping-cart",
                            "icon-style": "light"
                        })
                    ]),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    _createElementVNode("div", {
                        class: "cart__content",
                        onClick: _cache[1] || (_cache[1] = ($event) => (toggleCartSidebar()))
                    }, [
                        _createVNode(Spinner, { loading: loading.value }, null, 8, ["loading"]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (!loading.value && cart.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('cart.items_count', { count: cart.value.itemsCount })), 1),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(Price, {
                                        currency: cart.value.currency,
                                        amount: cart.value.orderTotal
                                    }, null, 8, ["currency", "amount"])
                                ])
                            ], 64))
                            : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (!loading.value && !cart.value && createOrderDraft.value)
                            ? (_openBlock(), _createBlock(CommandButton, {
                                key: 1,
                                command: createOrderDraft.value,
                                classes: ['button', 'button--link'],
                                label: _ctx.$t('cart.create')
                            }, null, 8, ["command", "label"]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[14] || (_cache[14] = _createTextVNode()),
                    (carts.value.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(AppDropdown, {
                                position: "left",
                                "button-style": "link",
                                onSelect: selectCart
                            }, {
                                button: _withCtx(() => [
                                    _createVNode(_component_icon, { name: "caret-down" })
                                ]),
                                menu: _withCtx((props) => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carts.value, (c) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            onClick: ($event) => (props.select(c)),
                                            key: c.id,
                                            class: "dropdown__item"
                                        }, [
                                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('cart.items_count', { count: c.itemsCount })), 1),
                                            _cache[5] || (_cache[5] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_6, [
                                                _createVNode(Price, {
                                                    currency: c.currency,
                                                    amount: c.orderTotal
                                                }, null, 8, ["currency", "amount"])
                                            ]),
                                            _cache[6] || (_cache[6] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_7, _toDisplayString(c.customer.firstName) + " " + _toDisplayString(c.customer.lastName), 1)
                                        ], 8, _hoisted_4));
                                    }), 128)),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    (_ctx.$isGranted('PORTAL_ORDERS_CREATE') && createOrderDraft.value)
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 0,
                                            command: createOrderDraft.value,
                                            class: "dropdown__item",
                                            classes: ['button', 'button--link'],
                                            label: _ctx.$t('cart.create'),
                                            icon: "plus"
                                        }, null, 8, ["command", "label"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                    _cache[15] || (_cache[15] = _createTextVNode()),
                    (addedItems.value.length > 0 && !cartSidebarOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t('cart.item_added')), 1),
                            _cache[12] || (_cache[12] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addedItems.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "cart__item"
                                }, [
                                    _createElementVNode("div", _hoisted_10, [
                                        (item.image)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: itemImageSrc(item)
                                            }, null, 8, _hoisted_11))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, _toDisplayString(item.quantity) + " " + _toDisplayString(item.unit === 'PC' ? '×' : item.unit) + " " + _toDisplayString(item.sku), 1),
                                        _cache[9] || (_cache[9] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1)
                                    ]),
                                    _cache[11] || (_cache[11] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("a", {
                                            onClick: _withModifiers(($event) => (undoAddCartItem(item)), ["prevent"]),
                                            title: _ctx.$t('cart.undo_add_item'),
                                            href: ""
                                        }, [
                                            _createVNode(_component_icon, { name: "undo" })
                                        ], 8, _hoisted_16)
                                    ])
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
